<template>
  <div class="flex-row start  ">
    <div class="wf flex-row left">{{ value.Name }}</div>
    <div class="flex-row w100   right">
      <div>题目数量:</div>
      <div class='active'>{{ value.TopicCount }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    config: Object
  }
}
</script>
   